import Input from '@/components/Common/Input';
import { Box, Paper } from '@mui/material';
import { useFormContext } from 'react-hook-form';

export default function AppointmentSchedulingConfig() {
  const { control } = useFormContext();

  return (
    <Paper variant='outlined' sx={{ p: 3 }}>
      <Input
        name='appointment_scheduling_details.cancellation_rules'
        control={control}
        label='Cancellation Rules'
        placeholder='e.g: Cancel at least 24 hours before the appointment. Late cancellations or no-shows are charged $50.'
        multiline
        minRows={3}
        maxRows={8}
        fullWidth
      />

      <Box mt={2}>
        <Input
          name='appointment_scheduling_details.rescheduling_rules'
          control={control}
          label='Rescheduling Rules'
          placeholder='e.g: Reschedule up to 2 times per appointment; offer the next 3 open slots with the same provider.'
          multiline
          minRows={3}
          maxRows={8}
          fullWidth
        />
      </Box>
    </Paper>
  );
}
